module.exports = __webpack_public_path__ + "img/collection-engagementRingsBestseller.e44c77b.webp";